// Single source of truth for the voice-models sort options, in display order. Add a new sort type here and ModelSortVariant (derived from this const) plus the dropdown pick it up automatically.
export const MODEL_SORT_OPTIONS = [
  { value: "default", label: "Default" },
  { value: "recent", label: "Recent" },
  { value: "popular", label: "Popular" },
] as const;
